module.exports = __webpack_public_path__ + "img/left_6.f280802f.png";